<template>
  <b-navbar type="light" class="navbar-backstage">
    <b-navbar-brand href="#">
      <img
        src="@/assets/image/quartercar-logo-small.svg"
        class="d-inline-block align-center"
        alt="logo"
        id="logoImage"
      />
      <small class="pl-2 d-none d-sm-inline-block">管理者後台</small>
    </b-navbar-brand>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item-dropdown right no-caret>
          <template v-slot:button-content>
            <b-iconstack>
              <b-icon
                stacked
                icon="bell-fill"
                variant="light"
                scale="0.8"
              ></b-icon>
              <b-icon
                v-if="has_news"
                stacked
                icon="dot"
                variant="danger"
                shift-h="4"
                shift-v="4"
                scale="2"
              ></b-icon>
            </b-iconstack>
          </template>
          <b-dropdown-item href="#">通知消息</b-dropdown-item>
        </b-nav-item-dropdown> -->
        <b-nav-item-dropdown right no-caret>
          <template v-slot:button-content>
            <b-icon icon="person-fill" variant="light"></b-icon>
            <span class="text-white px-2 d-none d-md-inline">嗨！管理者</span>
          </template>
          <b-dropdown-item href="#" @click="signOut">登出</b-dropdown-item>
        </b-nav-item-dropdown>
        <li class="nav-item collapsed d-md-none dinline-block">
          <a href="#sidebar" v-b-toggle class="nav-link">
            <b-icon icon="list" variant="light"></b-icon>
          </a>
        </li>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<style lang="scss" scoped>
.navbar-backstage {
  &::after {
    background-color: $manage_main;
  }
  &::before {
    border-color: transparent transparent $manage_main transparent;
  }
}
</style>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      has_news: false
    };
  },
  methods: {
    signOut() {
      localStorage.removeItem("manage-api_token");
      this.$router.push({ name: "管理者平台登入" });
    }
  }
};
</script>
